export const CredibilityIndexAction = {
    UPDATE_CLIENT_ID: 'UPDATE_CLIENT_ID',
    SET_CI_CONFIG_RESPONSE: 'SET_CI_CONFIG_RESPONSE',
    UPDATE_PAGE_VIEW: 'UPDATE_PAGE_VIEW',
    UPDATE_WEIGHTAGE_EDITING: 'UPDATE_WEIGHTAGE_EDITING',
    TOGGLE_EDIT_WEIGHTAGE: 'TOGGLE_EDIT_WEIGHTAGE',
    UPDATE_ACTIVE_PAGE: 'UPDATE_ACTIVE_PAGE',
    UPDATE_EDIT_CREDIBILITY_BAND: 'UPDATE_EDIT_CREDIBILITY_BAND',
    SET_OVERALL_BAND_EDITED: 'SET_OVERALL_BAND_EDITED',
    IS_LOADING: 'IS_LOADING',
    RESET_STATE: 'RESET_STATE'
};